import * as React from "react";
type Props = {
  className?: string,
};
function SvgTruck({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-truck"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6V17H3.17071C3.58254 15.8348 4.69378 15 6 15C7.30622 15 8.41746 15.8348 8.82929 17H13V6H3ZM15 7V5.5C15 4.67157 14.3284 4 13.5 4H2.5C1.67157 4 1 4.67157 1 5.5V17.5C1 18.3284 1.67157 19 2.5 19H3.17071C3.58254 20.1652 4.69378 21 6 21C7.30622 21 8.41746 20.1652 8.82929 19H13.5C13.6753 19 13.8436 18.9699 14 18.9146C14.1564 18.9699 14.3247 19 14.5 19H15.1707C15.5825 20.1652 16.6938 21 18 21C19.3062 21 20.4175 20.1652 20.8293 19H21.5C22.3284 19 23 18.3284 23 17.5V12.2071C23 11.8093 22.842 11.4278 22.5607 11.1464L18.8536 7.43934C18.5723 7.15804 18.1907 7 17.7929 7H15ZM15 9V17H15.1707C15.5825 15.8348 16.6938 15 18 15C19.3062 15 20.4175 15.8348 20.8293 17H21V12.4142L17.5858 9H15ZM6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17ZM18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgTruck;
